import React, { Component, createRef } from 'react';
import { Form, Field, FormSpy } from 'react-final-form';
import classnames from 'classnames';
import { connect } from 'react-redux';
import {
  messagesSelector,
  showManagerEmailFieldSelector
} from '../../helpers/selectors';
import { scrollToErrorInfo } from '../../helpers/scrollToError';
import _isEmpty from 'lodash/isEmpty';
import { PureTextField } from './fields/text';
import { getMessage as t, trimStrings } from '../../utils/utils';
import { checkEmail } from '../../helpers';
import { injectIntl } from 'react-intl';
import { setFormValues } from '../../actions/formMirror';

const validate = (values, props) => {
  const errors = {};
  const { m, showManagerEmail } = props;
  const { managerEmail } = trimStrings(values);

  if (showManagerEmail) {
    const emailError = checkEmail(managerEmail, m);

    if (emailError) errors.managerEmail = emailError;
  }

  return errors;
};

/**
 * @typedef {object} SpecialFieldsFormProps
 * @property {Function} [passFormSubmit]
 */
class SpecialFieldsForm extends Component {
  constructor(props) {
    super(props);
    this.formApiRef = createRef();
    this.bindFunctions();
  }

  componentDidMount() {
    this.passFormSubmit();
  }

  bindFunctions() {
    this.validateAndSubmit = this.validateAndSubmit.bind(this);
  }

  passFormSubmit() {
    const { passFormSubmit } = this.props;

    if (passFormSubmit) passFormSubmit(this.validateAndSubmit);
  }

  validateAndSubmit(action) {
    const formApi = this.formApiRef.current;
    const values = formApi ? formApi.getState().values : {};
    const errors = validate(values, this.props);

    if (_isEmpty(errors)) {
      action(values);
    } else {
      if (formApi) formApi.submit();
      scrollToErrorInfo();
    }
  }

  getLabelManagerEmail() {
    return t(this.props.m, 'label.manager.email');
  }

  render() {
    const { showManagerEmail, initialValues, dispatch } = this.props;
    const labelManagerEmail = this.getLabelManagerEmail();

    return (
      <Form
        onSubmit={() => {}}
        initialValues={initialValues}
        validate={(values) => validate(values, this.props)}
      >
        {({ form }) => {
          this.formApiRef.current = form;
          return (
            <form
              className={classnames('special-fields-form', 'scope-section')}
              onSubmit={(e) => e.preventDefault()}
              noValidate
            >
              <FormSpy
                subscription={{ values: true }}
                onChange={({ values }) =>
                  dispatch(setFormValues('specialFields', values))
                }
              />
              <div className="scope-section-title pb-xs-0 pt-dt-0" />
              <div className="scope-section-fields">
                {showManagerEmail && (
                  <Field
                    name="managerEmail"
                    label={labelManagerEmail}
                    placeholder={labelManagerEmail}
                    mandatory
                    component={PureTextField}
                  />
                )}
              </div>
            </form>
          );
        }}
      </Form>
    );
  }
}

export const SPECIAL_FIELDS_FIELDS_NAMES = ['managerEmail'];

function mapStateToProps(state) {
  return {
    m: messagesSelector(state),
    showManagerEmail: showManagerEmailFieldSelector(state)
  };
}

export default injectIntl(connect(mapStateToProps)(SpecialFieldsForm));
